<template>
  <path
    d="M14 6.00018L13.28 4.55018C13.11 4.21018 12.76 4.00018 12.38 4.00018H6C5.45 4.00018 5 4.45018 5 5.00018V20.0002C5 20.5502 5.45 21.0002 6 21.0002C6.55 21.0002 7 20.5502 7 20.0002V14.0002H12L12.72 15.4502C12.89 15.7902 13.24 16.0002 13.61 16.0002H19C19.55 16.0002 20 15.5502 20 15.0002V7.00018C20 6.45018 19.55 6.00018 19 6.00018H14ZM18 14.0002H14L13 12.0002H7V6.00018H12L13 8.00018H18V14.0002Z"
  />
</template>
